<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title" style="display: flex;align-items: center;">ព័ត៌មានអំពីកញ្ចប់ឥវ៉ាន់</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-33">
				<table>
					<tr>
						<td style="width: 150px">លេខកូដកញ្ចប់</td>
						<td style="width: 40px">:</td>
						<td>{{package.tracking}}</td>
					</tr>
					<tr>
						<td>ប្រភេទកញ្ចប់</td>
						<td>:</td>
						<td>{{package.package_type}}</td>
					</tr>
					<tr>
						<td>ទីតាំង</td>
						<td>:</td>
						<td>{{package.location}}</td>
					</tr>
					<tr>
						<td>អ្នកទទួល</td>
						<td>:</td>
						<td>{{package.receiver_phone}}</td>
					</tr>
					<tr>
						<td>តម្លៃឥវ៉ាន់</td>
						<td>:</td>
						<td><b>{{config.moneylify(package.price, package.price_currency)}}
								<span v-if="package.price == 0">(ទូទាត់រួច)</span>
								<span v-if="package.price > 0">(មិនទាន់ទូទាត់)</span>
							</b></td>
					</tr>
					<tr>
						<td>ថ្លៃដឹកជញ្ជូន</td>
						<td>:</td>
						<td><b>{{config.moneylify(package.fee, package.fee_currency)}}
								({{config.getStatus(package.fee_responsible)}})</b></td>
					</tr>
					<tr>
						<td>ស្ថានភាព</td>
						<td>:</td>
						<td>
							<span class="error" v-if="package.package_status == 'ndv'">{{
								config.getStatus(package.package_status) }}</span>
							<span class="late" v-if="package.package_status == 'wdv'">{{
								config.getStatus(package.package_status) }}</span>
							<span class="neutral" v-if="package.package_status == 'dvr'">{{
								config.getStatus(package.package_status) }}</span>
							<span class="green" v-if="package.package_status == 'dlv'">{{
								config.getStatus(package.package_status) }}</span>
							<span class="return" v-if="package.package_status == 'rtn'">{{
								config.getStatus(package.package_status) }}</span>
						</td>
					</tr>
					<tr>
						<td>បានបញ្ចូលដោយ</td>
						<td>:</td>
						<td>{{package.created_by}}</td>
					</tr>
					<tr>
						<td>បានបញ្ជាក់ទូទាត់រួចដោយ</td>
						<td>:</td>
						<td>{{package.paid_by}}</td>
					</tr>
					<tr>
						<td>បានត្រឡប់ដោយ</td>
						<td>:</td>
						<td>{{package.returned_by}}</td>
					</tr>

				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-33">
				<table style="border-width: 0px;">

					<tr>
						<td style="width: 150px">ឈ្មោះអតិថិជន</td>
						<td style="width:40px">:</td>
						<td>{{package.client_name}}</td>
					</tr>
					<tr>
						<td>លេខទូរស័ព្ទ</td>
						<td>:</td>
						<td>{{package.client_phone}}</td>
					</tr>
					<tr>
						<td>កំណត់ចំណាំអតិថិជន</td>
						<td>:</td>
						<td>{{package.client_note}}</td>
					</tr>
					<tr>
						<td>អ្នកដឹកជញ្ជូន</td>
						<td>:</td>
						<td>{{package.driver_name}}</td>
					</tr>
					<tr>
						<td>លេខទូរស័ព្ទអ្នកដឹកជញ្ជូន</td>
						<td>:</td>
						<td>{{package.driver_phone}}</td>
					</tr>
				</table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-33">
				<qr-code :text="'admin-'+package.hash_id" :size="300" style="width: 180px"></qr-code>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title">កំណត់ចំណាំរបស់កញ្ចប់ឥវ៉ាន់</h3>
				<p v-if="String(package.package_note).length > 0">{{package.package_note}}</p>
				<p v-else>មិនមាន</p>
			</div>
		</div>
	</div>
</template>
<script>
	import VueQRCodeComponent from 'vue-qr-generator'
	export default {
		components: {
			'qr-code': VueQRCodeComponent,
		},
		created() {
			this.getPackage();
			// this.getPayment();
		},
		data() {
			return {
				loaded: false,
				paymentList: [],
				payDialog: false,
				returnDialog: false,
				payID: "",
				returnID: "",
				package: {
					id: "",
					hash_id: "",
					tracking: "",
					client_name: "",
					client_phone: "",
					client_note: "",
					location: "",
					receiver_phone: "",
					package_status: "",
					driver_note: "",
					package_note: "",
					driver_name: "",
					driver_phone: "",
					note: "",
					fee_responsible: ""
				},
				note: ""
			}
		},
		methods: {
			getPackage(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/package/get/" + this.$route.params.hash_id).then(data => {
					this.package = data.body.data
					// console.log(data.body.data)
					this.loaded = true
				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/DriverPackages/Detail.vue